import React from "react";

import {
  FiBriefcase,
  FiCalendar,
  FiClipboard,
  FiEdit2,
  FiHome,
  FiMail,
  FiMapPin,
  FiPhone,
  FiUser,
  FiX,
} from "react-icons/fi";

const formatDate = (value) => {
  if (!value) {
    return "-";
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "-";
  }

  return new Intl.DateTimeFormat("en-IN", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(date);
};

const getStatusClass = (status) => {
  switch (status) {
    case "Active":
      return "customer-status-active";

    case "Inactive":
      return "customer-status-inactive";

    case "Blocked":
      return "customer-status-blocked";

    default:
      return "customer-status-active";
  }
};

const CustomerDrawer = ({
  open,
  customer,
  onClose,
  onEdit,
  onOpenRequirements,
}) => {
  if (!open || !customer) {
    return null;
  }

  const customerName =
    customer?.customerName ||
    customer?.name ||
    "Unknown Customer";

  const mobile =
    customer?.mobile ||
    customer?.phone ||
    "-";

  const email =
    customer?.email || "-";

  const companyName =
    customer?.companyName || "-";

  const address =
    customer?.address || "-";

  const status =
    customer?.status || "Active";

  const customerInitial = String(
    customerName || "C"
  )
    .charAt(0)
    .toUpperCase();

  return (
    <div className="customer-drawer-overlay">
      <button
        type="button"
        className="customer-drawer-backdrop"
        onClick={onClose}
        aria-label="Close customer details"
      />

      <aside
        className="customer-drawer"
        role="dialog"
        aria-modal="true"
        aria-label="Customer details"
      >
        <div className="customer-drawer-header">
          <div>
            <span>
              CUSTOMER PROFILE
            </span>

            <h2>
              Customer Details
            </h2>
          </div>

          <button
            type="button"
            className="customer-drawer-close"
            onClick={onClose}
            aria-label="Close drawer"
          >
            <FiX />
          </button>
        </div>

        <div className="customer-drawer-body">
          <section className="customer-drawer-card">
            <div className="customer-drawer-profile">
              <div className="customer-drawer-avatar">
                {customerInitial}
              </div>

              <div className="customer-drawer-profile-info">
                <strong>
                  {customerName}
                </strong>

                <span>
                  Customer ID:{" "}
                  {customer?._id
                    ? customer._id.slice(-8)
                    : "-"}
                </span>

                <span
                  className={`customer-status-badge ${getStatusClass(
                    status
                  )}`}
                  style={{
                    width: "fit-content",
                    cursor: "default",
                  }}
                >
                  {status}
                </span>
              </div>
            </div>
          </section>

          <section className="customer-drawer-card">
            <h3>
              Contact Information
            </h3>

            <div className="customer-drawer-detail-row">
              <FiUser />

              <div>
                <span>
                  Customer Name
                </span>

                <strong>
                  {customerName}
                </strong>
              </div>
            </div>

            <div className="customer-drawer-detail-row">
              <FiPhone />

              <div>
                <span>
                  Mobile Number
                </span>

                <strong>
                  {mobile}
                </strong>
              </div>
            </div>

            <div className="customer-drawer-detail-row">
              <FiMail />

              <div>
                <span>
                  Email Address
                </span>

                <strong>
                  {email}
                </strong>
              </div>
            </div>
          </section>

          <section className="customer-drawer-card">
            <h3>
              Business Information
            </h3>

            <div className="customer-drawer-detail-row">
              <FiBriefcase />

              <div>
                <span>
                  Company Name
                </span>

                <strong>
                  {companyName}
                </strong>
              </div>
            </div>

            <div className="customer-drawer-detail-row">
              <FiMapPin />

              <div>
                <span>
                  Address
                </span>

                <strong>
                  {address}
                </strong>
              </div>
            </div>
          </section>

          <section className="customer-drawer-card">
            <h3>
              Account Information
            </h3>

            <div className="customer-drawer-detail-row">
              <FiCalendar />

              <div>
                <span>
                  Created On
                </span>

                <strong>
                  {formatDate(
                    customer?.createdAt
                  )}
                </strong>
              </div>
            </div>

            <div className="customer-drawer-detail-row">
              <FiCalendar />

              <div>
                <span>
                  Last Updated
                </span>

                <strong>
                  {formatDate(
                    customer?.updatedAt
                  )}
                </strong>
              </div>
            </div>

            <div className="customer-drawer-detail-row">
              <FiHome />

              <div>
                <span>
                  Current Status
                </span>

                <strong>
                  {status}
                </strong>
              </div>
            </div>
          </section>
        </div>

        <div className="customer-drawer-footer">
          <button
            type="button"
            className="customer-drawer-edit-button"
            onClick={() =>
              onEdit(customer)
            }
          >
            <FiEdit2 />

            Edit Customer
          </button>

          <button
            type="button"
            className="customer-drawer-requirements-button"
            onClick={() => {
              if (
                typeof onOpenRequirements ===
                "function"
              ) {
                onOpenRequirements(customer);
              }
            }}
          >
            <FiClipboard />

            View Requirements
          </button>
        </div>
      </aside>
    </div>
  );
};

export default CustomerDrawer;